export function bufferToArrayBuffer(buffer) {
  if (Buffer.isBuffer(buffer)) {
    var typedArray = new Uint8Array(buffer);
    return typedArray.buffer;
  }

  return buffer;
}
//# sourceMappingURL=to-array-buffer.node.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@loaders.gl/polyfills/dist/esm/utils/to-array-buffer.node.js
// module id = 779
// module chunks = 0